import axios from "axios";
import VPagination from "@hennge/vue3-pagination";
import store from "@/store";

export default {
  name: "ScheduleOfAssessmentManagement",
  components: {
    VPagination,
  },
  data() {
    return {
      scheduleOfAssessments: [],
      editIndex: null,
      editableRow: null,
      protocolId: "",
      idToken: "",
      pageindex: 1,
      pageSize: 10,
      SortProperty: "visitNumber",
      ConvertToNumeric :true,
      sortorder: 0,
      totalPages: 1,
      totalCount: 0,
      currentPage: 1,
      loadNextPage: false,
      baseurl: process.env.VUE_APP_Service_URL,
      validationErrors: {},
      isAddingNew: false,
      newRow: {
        visitNumber: "",
        activityId: "",
        activityOrder: null,
        activityName: "",
        activityType: "",
        isRequired: true,
        soaId: "",
      },
      newRowErrors: {},

      protocol: {},
    };
  },
  async mounted() {
    this.idToken = store.getters.getIdToken;
    this.protocolId = this.$route.query.id;

    await this.getProtocolbyId();
    if (this.protocolId) {
      await this.listScheduleOfAssessments(this.protocolId);
    }
  },
  methods: {
    async listScheduleOfAssessments(protocolId) {
      await axios
        .get(
          `${this.baseurl}/management/studyprotocol/listdascheduleassessments?protocolId=${this.protocolId}&pageindex=${this.pageindex}&pagesize=${this.pageSize}&SortProperty=${this.SortProperty}&SortOrder=${this.sortorder}`,
          {
            headers: {
              Authorization: "Bearer " + this.idToken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.scheduleOfAssessments = res.data.results;
          this.totalCount = res.data.totalCount;
          this.totalPages = Math.ceil(res.data.totalCount / this.pageSize);
        })
        .catch((err) => console.log("Error in fetching schedule of assessments:", err));
    },
    editRow(index, soa) {
      this.editIndex = index;
      this.editableRow = { ...soa };
      this.validationErrors = {};
    },
    validateRow() {
      this.validationErrors = {};
      if (!this.editableRow.visitNumber) {
        this.validationErrors.visitNumber = "Visit Number is required.";
      }
      if (!this.editableRow.activityId) {
        this.validationErrors.activityId = "Activity ID is required.";
      }

      return Object.keys(this.validationErrors).length === 0;
    },
    async updateRow(daScheduleOfAssessmentId) {
      try {
        if (!this.editableRow) {
          console.error("No editable row found.");
          return;
        }

        if (!this.validateRow()) {
          return;
        }

        const updateData = {
          daScheduleAssessmentId: daScheduleOfAssessmentId,
          protocolRefId: this.protocolId,
          studyId: this.protocol.studyId,
          visitNumber: this.editableRow.visitNumber,
          activityId: this.editableRow.activityId,
          activityOrder: this.editableRow.activityOrder,
          activityName: this.editableRow.activityName,
          activityType: this.editableRow.activityType,
          isRequired: this.editableRow.isRequired,
          soaId: this.editableRow.soAId,
        };

        const response = await axios.put(
          `${this.baseurl}/management/studyprotocol/updatedascheduleassessments`,
          updateData,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Update response:", response.data);

        await this.getProtocolbyId();
        this.cancelEdit();
        await this.listScheduleOfAssessments(this.protocolId);

        alert("Schedule of assessment details updated successfully.");
      } catch (err) {
        console.error("Error during updateRow API call:", err);
        alert("Failed to update schedule of assessment. Please try again.");
      }
    },
    cancelEdit() {
      this.editIndex = null;
      this.editableRow = null;
    },
    clearFieldError(fieldName) {
      if (this.validationErrors[fieldName]) {
        delete this.validationErrors[fieldName];
      }
    },
    async loadPage(page) {
      this.currentPage = page;
      this.pageindex = page;
      this.loadNextPage = true;
      await this.listScheduleOfAssessments(this.protocolId);
    },
    async deleteRow(soaId) {
      try {
        const confirmation = confirm("Are you sure you want to delete this schedule of assessment?");
        if (!confirmation) return;

        const response = await axios.delete(
          `${this.baseurl}/management/studyprotocol/deletebyid?collectionName=DaScrape_ScheduleAssessments&id=${soaId}`,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Delete response:", response.data);
        await this.listScheduleOfAssessments(this.protocolId);
        if (this.scheduleOfAssessments.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          this.pageindex = this.currentPage;
          await this.listScheduleOfAssessments(this.protocolId);
        }
        alert("Schedule of assessment deleted successfully.");
      } catch (error) {
        console.error("Error during schedule of assessment delete API call:", error);
        alert("Failed to delete the schedule of assessment entry. Please try again.");
      }
    },
    async getProtocolbyId() {
      const token = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/document/getprotocolbyid?protocolId=${this.protocolId}`,
          {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.protocol = res.data;
        })
        .catch((err) => console.log("error in get protocol by id", err));
    },
    addNewRow() {
      this.isAddingNew = true;
      this.newRow = {
        visitNumber: "",
        activityId: "",
        activityOrder: null,
        activityName: "",
        activityType: "",
        isRequired: true,
        soaId: "",
      };
      this.newRowErrors = {};
      // Cancel any active inline edit
      this.editIndex = null;
      this.editableRow = null;
    },

    cancelNewRow() {
      this.isAddingNew = false;
      this.newRowErrors = {};
    },

    clearNewFieldError(fieldName) {
      if (this.newRowErrors[fieldName]) {
        delete this.newRowErrors[fieldName];
      }
    },

    validateNewRow() {
      this.newRowErrors = {};
      if (!this.newRow.visitNumber) {
        this.newRowErrors.visitNumber = "Visit Number is required.";
      }
      if (!this.newRow.activityId) {
        this.newRowErrors.activityId = "Activity ID is required.";
      }
      return Object.keys(this.newRowErrors).length === 0;
    },

    async saveNewRow() {
      if (!this.validateNewRow()) return;

      try {
        const payload = {
          collectionName: "DaScrape_ScheduleAssessments",
          data: {
            protocolRefId: this.protocolId,
            studyId: this.protocol.studyId,
            visitNumber: this.newRow.visitNumber,
            activityId: this.newRow.activityId,
            activityOrder: this.newRow.activityOrder,
            activityName: this.newRow.activityName,
            activityType: this.newRow.activityType,
            isRequired: this.newRow.isRequired,
            soaId: this.newRow.soaId,
          },
        };

        await axios.post(
          `${this.baseurl}/management/studyprotocol/genericinsert`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        this.isAddingNew = false;
        this.newRowErrors = {};

        await this.listScheduleOfAssessments(this.protocolId);

        alert("Schedule of assessment created successfully.");
      } catch (err) {
        console.error("Error creating schedule of assessment entry:", err);
        alert("Failed to create schedule of assessment entry. Please try again.");
      }
    }
  },
};